import React from "react";
import hocWrapper from "./hocWrapper";

const Line = props => {
    return <hr className={props.className} />;
};
export default hocWrapper(Line);
